import { createStore } from 'zustand/vanilla';
/** @import { StoreApi } from 'zustand/vanilla'; */

/**
 * @typedef {Object} ActiveJobState
 * @property {string|null} id - The ID of the active job, or null if no job is active.
 * @property {Object|null} geohash - The geohash data for the active job, or null if no geohash is loaded.
 * @property {(jobId: string|null) => void} setId - Function to set the active job ID.
 * @property {(geohash: Object|null) => void} setGeohash - Function to set the active job's geohash data.
 * @property {() => void} clear - Function to reset the active job state to its initial values.
 */

/**
 * @typedef {StoreApi<ActiveJobState>} ActiveJobStore
 */

/**
 * Store for managing the state of the active job in the application.
 * @type {ActiveJobStore}
 */
export const activeJobStore = createStore((set, get, _store) => ({
  id: null,
  geohash: null,

  setId: (jobId) => set({ id: jobId }),
  setGeohash: (geohash) => set({ geohash }),
  clear: () => set(_store.getInitialState())
}));
